var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{},[_c('img',{staticClass:"img",attrs:{"src":_vm.src,"alt":""},on:{"click":function($event){_vm.showPreview=true}}}),_c('preview-img',{key:_vm.src,attrs:{"show":_vm.showPreview,"fileType":"image","previewlist":_vm.getpreivewlist(),"currentUrl":_vm.src},on:{"close":function($event){_vm.showPreview=false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }